import React from 'react';

export const HOME_PAGE_FAQS = {
		general: [
			{
				header: 'Issues logging into your account?',
				item: (
					<p>
						For issues or questions related to your account, call 800-442-6459 or email{' '}
						<a href='mailto:contact@go.wisconsin.edu'>contact@go.wisconsin.edu</a>.
					</p>
				)
			},
			{
				header: 'How can I get help with my Universities of Wisconsin Application?',
				item: (
					<p>
						For assistance with the Universities of Wisconsin Application, call{' '}
						<a href='tel:+1-800-442-6459'>800-442-6459</a> or email{' '}
						<a href='mailto:contact@go.wisconsin.edu'>contact@go.wisconsin.edu</a>.
					</p>
				)
			},
			{
				header: 'Is there an application fee for undergraduate applications?',
				item: (
					<>
						<p>
							Beginning August 1, 2025 for first-year and transfer applicants for the Fall 2026 term, the
							following UW universities charge an application fee for every application submitted: UW-Eau
							Claire ($25), UW-La Crosse ($25), and UW-Madison ($80). For the other UW universities, there
							is no application fee.
						</p>
						<p>
							For domestic applicants, if you are concerned about paying application fees, please note
							your financial hardship on the Personal Information section of the application.
						</p>
					</>
				)
			},
			{
				header: 'How can I make changes to my submitted application?',
				item: (
					<>
						<p>
							If you have already submitted your application, please contact the admissions office
							directly to update your information.
						</p>
						<ul>
							<li>
								<a
									href='https://uwhelp.wisconsin.edu/resources/campus-contacts/?type=undergraduate-admissions'
									target='_blank'>
									Undergraduate admissions
								</a>
							</li>
							<li>
								<a
									href='https://uwhelp.wisconsin.edu/resources/campus-contacts/?type=graduate-admissions'
									target='_blank'>
									Graduate admissions
								</a>
							</li>
						</ul>
					</>
				)
			},
			{
				header: 'What is the status of my application?',
				item: (
					<>
						<p>
							Please contact the campus's admissions office directly with your full name, date of birth,
							and application ID. The admissions office will be able to share the status of your
							application.
						</p>
						<ul>
							<li>
								<a
									href='https://uwhelp.wisconsin.edu/resources/campus-contacts/?type=undergraduate-admissions'
									target='_blank'
									rel='noopener noreferrer'>
									Undergraduate admissions
								</a>
							</li>
							<li>
								<a
									href='https://uwhelp.wisconsin.edu/resources/campus-contacts/?type=graduate-admissions'
									target='_blank'
									rel='noopener noreferrer'>
									Graduate admissions
								</a>
							</li>
						</ul>
					</>
				)
			},
			{
				header: 'What classes are available?',
				item: (
					<>
						<p>
							Check out each{' '}
							<a
								href='https://uwhelp.wisconsin.edu/post-admission/uw-campus-timetables/'
								target='_blank'
								rel='noopener noreferrer'>
								campus's schedule of classes
							</a>{' '}
							or undergraduate catalog to find the perfect class for you.
						</p>
						<p>
							To view how credits may transfer to a UW, use the{' '}
							<a
								href='https://www.transferology.com/state/wisconsin.htm'
								target='_blank'
								rel='noopener noreferrer'>
								Transferology
							</a>{' '}
							tool or contact your Academic Advisor.
						</p>
					</>
				)
			}
		],
		direct_admit: [
			{
				header: 'Issues logging into your account?',
				item: (
					<p>
						For issues or questions related to your account, call 800-442-6459 or email{' '}
						<a href='mailto:contact@go.wisconsin.edu'>contact@go.wisconsin.edu</a>.
					</p>
				)
			},
			{
				header: 'What is Direct Admit Wisconsin?',
				item: (
					<p>
						Direct Admit Wisconsin is an initiative by the Universities of Wisconsin to proactively offer
						admission to qualified Wisconsin high school students. For more information, visit{' '}
						<a href='https://www.wisconsin.edu/direct-admissions/' target='__blank'>
							the Direct Admit Wisconsin website
						</a>
						.
					</p>
				)
			},
			{
				header: 'How can I get help with my Direct Admit Form(s)?',
				item: (
					<p>
						For assistance with the Direct Admit Form, call <a href='tel:+1-800-442-6459'>800-442-6459</a>{' '}
						or email <a href='mailto:contact@go.wisconsin.edu'>contact@go.wisconsin.edu</a>.
					</p>
				)
			},
			{
				header: 'If I already have a Universities of Wisconsin Admission Pathway Portal account, how do I view my Direct Admit admissions offers?',
				item: (
					<p>
						Log into your existing account with your email. Once logged in, you will see a “Direct Admit”
						tab. Click on the button “Link Your Direct Admit Record.” Follow the instructions to access your
						Direct Admit admissions offers.
					</p>
				)
			},
			{
				header: 'How do I know which UWs I have received Direct Admit admissions offers from?',
				item: (
					<p>
						When logged into your Universities of Wisconsin Admission Pathway Portal account, you can find a
						list of the UWs that have offered you Direct Admissions.
					</p>
				)
			},
			{
				header: 'I am interested in a UW university that is not on my Direct Admit admission offer list. What should I do?',
				item: (
					<p>
						You can apply for admission to any UW not on your Direct Admit offer letter by submitting a
						traditional application at apply.wisconsin.edu.
					</p>
				)
			},
			{
				header: 'Is the offer of admission to the UW university or to a specific major/academic program?',
				item: (
					<p>
						The Direct Admit admission offer is to the UW university. Some UW universities may have a
						secondary admission process in which students need to apply to be admitted into a specific
						major/academic program. Contact the UW university or academic program for more information.
					</p>
				)
			},
			{
				header: 'What happens after I submit a Direct Admit Form?',
				item: (
					<p>
						After you submit a Direct Admit Form, the UW university you are interested in will reach out to
						you with more information. Be sure to check your email for updates.
					</p>
				)
			},
			{
				header: 'Is Direct Admit Wisconsin the same thing as the Wisconsin Guarantee? ',
				item: (
					<p>
						Direct Admit Wisconsin and the Wisconsin Guarantee are different programs. For more information
						about the Wisconsin Guarantee, visit{' '}
						<a href='https://www.wisconsin.edu/wisconsin-guarantee/' target='__blank'>
							the Wisconsin Guarantee website
						</a>
						.
					</p>
				)
			}
		],
		reciprocity: [
			{
				header: 'What is reciprocity?',
				item: (
					<p>
						Reciprocity is a program that allows Wisconsin residents to attend public institutions in other
						states at a reduced tuition rate, similar to what they would pay if they were attending a school
						in Wisconsin. This arrangement is typically based on agreements between states to provide mutual
						benefits to their residents. For example, the Minnesota-Wisconsin Reciprocity Tuition Program
						allows students from Wisconsin to attend Minnesota public colleges and universities at in-state
						tuition rates. This program is supported by{' '}
						<a href='https://docs.legis.wisconsin.gov/statutes/statutes/36/27' target='__blank'>
							Wisconsin State Statutes, section 36.27
						</a>
						.
					</p>
				)
			},
			{
				header: 'Who should use this application?',
				item: (
					<>
						<p>Wisconsin residents attending Minnesota public institutions.</p>
						<p>
							The Minnesota/Wisconsin reciprocity agreement allows Wisconsin residents to attend Minnesota
							public universities at in-state tuition rates.
						</p>
						<p>
							This online reciprocity application is designed for Wisconsin residents attending Minnesota
							public institutions. Applying online through our application is the easiest way to apply for
							reciprocity benefits.
						</p>
					</>
				)
			},
			{
				header: 'Who should not use this application?',
				item: (
					<>
						<p>Minnesota residents.</p>
						<ul>
							<li>
								Minnesota residents should apply through the{' '}
								<a href='https://www.ohe.state.mn.us/' target='__blank'>
									Minnesota Office of Higher Education
								</a>
								.
							</li>
						</ul>
						<p>
							Students attending a Minnesota stand-alone Technical College SHOULD NOT USE THIS
							APPLICATION. Instead, apply directly to the college.
						</p>
						<p>
							Private colleges do NOT participate in the tuition reciprocity program because they do not
							charge non-resident tuition rates.
						</p>
						<p>
							Professional students enrolling in a Doctor of Medicine, Doctor of Dental Sciences, or
							Doctor of Veterinary Medicine program in the public institutions of either state are
							ineligible for reciprocity tuition.
						</p>
					</>
				)
			},
			{
				header: 'I already received reciprocity benefits and applied under WHEAB. Do I need to reapply?',
				item: (
					<p>
						Students enrolled under reciprocity who earned credits that were reported by the institution to
						the WHEAB during any semester of the current academic year will automatically have benefits
						renewed for the upcoming academic year at the institution they are currently attending.
						Therefore, these students need not reapply.
					</p>
				)
			}
		]
	},
	formatNotificationBody = objNotification => {
		let { field_notification_body, field_link_url } = objNotification,
			content = `${field_notification_body}`,
			strs = field_notification_body.split('|');

		if (strs.length > 1) {
			if (!field_link_url || strs.length !== 3) {
				content = content.split('|').join('');
			} else {
				const external_url = !field_link_url.indexOf('http'),
					link = external_url ? (
						<a href={field_link_url} target='_blank' rel='noopener noreferrer'>
							{strs[1]}
						</a>
					) : (
						<a href={field_link_url}>{strs[1]}</a>
					);

				content = (
					<>
						{strs[0]}
						{link}
						{strs[2]}
					</>
				);
			}
		}

		return <span>{content}</span>;
	};
